<template>
  <div class="link-button__container">
    <el-button
        v-if="visible"
        type="text"
        :disabled="disabled"
        @click="$emit('click', true)">
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "TextLink",
  emits: ["click"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    visible: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/newui/fonts.scss";

.link-button__container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.el-button--text,
.el-button--text:hover {
  @include text-link__normal-medium();
  padding: 0;
}
</style>
